export default __webpack_public_path__ + "static/media/m2_ulmtDts.c3c4e7d9.png";